module.exports = __webpack_public_path__ + "static/media/img-slide2.89eb5001.jpg";